<template>
  <div>
    <div class="video-matrix">
      <video-panel v-for="video in videos" :key="video.video_id" class="vim" :video="video" v-on:select="showVideo" noartist></video-panel>
    </div>
    <video-popup :videoId="selectedId" v-on:close="handleClose" v-on:tag="handleTag" />
  </div>
</template>

<script>
import VideoPanel from '@/views/videos/VideoPanel.vue'
import VideoPopup from '@/views/videos/VideoPopup.vue'
import apix from '@/api.js'

export default {
  components: {
    VideoPanel,
    VideoPopup
  },
  props: {
    artist: Object
  },
  data () {
    return {
      videos: [],
      selectedId: 0
    }
  },
  created () {
    this.init ()
  },
  methods: {
    async init () {
      if(this.artist) {
        let tag = this.$k.tagToUrl(this.artist.formatted_name)
        let res = await apix.get('videos/bytag/' + tag)
        this.videos = res.data
        this.$k.setMetatags("Lastest videos from " + this.artist.formatted_name,
                    "Here you will find the latest videos from " + this.artist.formatted_name)
      }
    },
    async showVideo (video) {
      this.selectedId = video.video_id
    },
    handleClose () {
      this.selectedId = 0
    },
    handleTag(tag) {
      this.$ixr.push('/videos/tags/' + this.$k.tagToUrl(tag))
    }
  },
  watch: {
    artist () {
      this.init()
    }
  }
}
</script>

<style>
.video-matrix{
  display:flex;
  flex-wrap:wrap;
  justify-content: space-between;
}
</style>